<template>
  <div class="print-page">
    <div class="no-print controls">
      <button @click="printNow()" class="print-btn">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="6 9 6 2 18 2 18 9" />
          <path
            d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
          />
          <rect x="6" y="14" width="12" height="8" />
        </svg>
        Print
      </button>
      <router-link to="/feesdefaulters" class="back-btn">← Back</router-link>
    </div>

    <div v-if="loading" class="no-data">
      <b-spinner type="grow" small></b-spinner> Loading defaulters...
    </div>

    <div v-else-if="!hasData" class="no-data">
      No defaulters found for the selected filters.
    </div>

    <div v-else>
      <h4
        style="text-align: center; text-transform: uppercase; border-bottom: 2px solid #000;"
      >
        {{ class_name }} Fees Defaulters - {{ termName }} {{ year }}
      </h4>
      <div
        v-for="(students, streamName) in groupedByStream"
        :key="streamName"
        class="stream-block"
      >
        <div class="stream-header">
          <h2>{{ streamName }}</h2>
        </div>

        <div class="student-list">
          <div
            v-for="(student, index) in students"
            :key="student.id"
            class="student-row"
          >
            <span class="num">{{ index + 1 }}.</span>
            <span class="name">
              {{ student.student.first_name }} {{ student.student.last_name }}
              <small> - {{ student.student.student_id }}</small>
            </span>
            <span class="balance">UGX {{ commas(student.balance) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PrintFeesDefaulters",
  data() {
    return {
      feesdefaulters: [],
      loading: true,
      termName: "",
      year: "",
    };
  },
  computed: {
    hasData() {
      return (
        Array.isArray(this.feesdefaulters) && this.feesdefaulters.length > 0
      );
    },
    groupedByStream() {
      const groups = {};
      this.feesdefaulters.forEach((item) => {
        const streamName = item.stream?.name || "Unknown Stream";
        if (!groups[streamName]) groups[streamName] = [];
        groups[streamName].push(item);
      });
      Object.keys(groups).forEach((key) => {
        groups[key].sort((a, b) =>
          a.student.last_name.localeCompare(b.student.last_name),
        );
      });
      return groups;
    },
  },
  async mounted() {
    const {
      term,
      term_name,
      year,
      class: classId,
      class_name: className,
    } = this.$route.query;
    this.termName = term_name || "";
    this.year = year || "";
    this.class_name = className || "";

    if (!term || !year || !classId) {
      this.loading = false;
      return;
    }

    try {
      const formData = new FormData();
      formData.append("term", term);
      formData.append("year", year);
      formData.append("class", classId);

      const response = await axios.post("/defaulters", formData);
      if (response.status === 200) {
        this.feesdefaulters = Array.isArray(response.data.feesdefaulters)
          ? response.data.feesdefaulters
          : [];
      }
    } catch (e) {
      //console.error("Failed to load defaulters:", e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    commas(x) {
      if (x == null) return "0";
      return Number(x).toLocaleString();
    },
    streamTotal(students) {
      return students.reduce((sum, s) => sum + Number(s.balance || 0), 0);
    },
    printNow() {
      window.print();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;600&family=DM+Sans:wght@400;500&display=swap");

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.print-page {
  font-family: "DM Sans", sans-serif;
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 32px;
  background: #fff;
  color: #111;
  min-height: 100vh;
}

.no-print.controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 36px;
}
.print-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.back-btn {
  font-size: 14px;
  color: #666;
  text-decoration: none;
}
.back-btn:hover {
  color: #111;
}

.no-data {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 15px;
}

.stream-block {
  margin-bottom: 52px;
  page-break-inside: avoid;
}

.stream-header {
  padding-bottom: 10px;
  margin-bottom: 4px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.stream-header h2 {
  font-family: "EB Garamond", serif;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.01em;
}
.stream-header .meta {
  font-size: 12px;
  color: #777;
  white-space: nowrap;
}

.student-list {
  margin-bottom: 8px;
}
.student-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 7px 0;
  border-bottom: 1px solid #eee;
}
.student-row:last-child {
  border-bottom: none;
}

.num {
  font-size: 12px;
  color: #aaa;
  min-width: 22px;
  text-align: right;
  flex-shrink: 0;
}
.name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
}
.name small {
  font-size: 11px;
  color: #888;
  font-weight: 400;
  margin-left: 8px;
}
.balance {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  flex-shrink: 0;
}

.stream-footer {
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0;
  font-size: 12px;
  color: #555;
  border-top: 1px solid #ddd;
  margin-top: 6px;
}
.stream-footer b {
  color: #111;
}

@media print {
  .no-print {
    display: none !important;
  }
  .print-page {
    padding: 20px;
  }
  .stream-block {
    page-break-inside: avoid;
    margin-bottom: 36px;
  }
}
</style>
